import axios from 'axios';
import config from './config';
import { getSessionToken } from './utils';

export const parseAPIuseX = axios.create({
  baseURL: config.PARSE_SERVER_URL,
  headers: {
    'X-Parse-Application-Id': config.PARSE_APP_ID,
    'X-Parse-JavaScript-Key': config.PARSE_JAVASCRIPT_KEY,
  },
});

parseAPIuseX.interceptors.request.use(axiosConfig => {
  const cfg = axiosConfig;
  cfg.headers['X-Parse-Session-Token'] = getSessionToken();

  return cfg;
});

parseAPIuseX.interceptors.response.use(
  response => {
    const { success } = response.data;
    if (success) {
      return response.data;
    }

    return Promise.reject(response.data);
  },
  error => {
    const errorMessage = error.response
      ? error.response.data.error
        ? error.response.data.error.message
        : error.response.data.message
      : error.message;
    return Promise.reject(errorMessage);
  },
);

export const parseAPI = axios.create({
  baseURL: config.PARSE_SERVER_URL,
  headers: {
    'Content-Type': 'text/plain',
  },
});

parseAPI.interceptors.request.use(
  request => {
    if (request.headers['Content-Type'] === 'text/plain') {
      request.data = {
        ...request.data,
        _ApplicationId: config.PARSE_APP_ID,
        _JavaScriptKey: config.PARSE_JAVASCRIPT_KEY,
        _SessionToken: getSessionToken(),
      };
    }
    return request;
  },
  error => Promise.reject(error),
);

parseAPI.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (error?.response?.status === 429 || error?.response?.status >= 500) {
      throw new Error('server-error');
    }
    if (error?.response?.data?.error === 'invalid session token') {
      throw new Error('invalid-session-token');
    }
    if (error?.response?.data?.code === 'unauthorized') {
      throw new Error('invalid-session-token');
    }
    return Promise.reject(error);
  },
);

export const fileUploadInstance = axios.create();

fileUploadInstance.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error),
);

const baseAPI = axios.create({
  baseURL: config.MA_SERVER_URL,
});

baseAPI.interceptors.request.use(
  request => {
    request.headers = {
      ...request.headers,
      _ApplicationId: config.PARSE_APP_ID,
      _JavaScriptKey: config.PARSE_JAVASCRIPT_KEY,
      _SessionToken: getSessionToken(),
    };
    return request;
  },
  error => Promise.reject(error),
);

baseAPI.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (error?.response?.status === 429 || error?.response?.status >= 500) {
      throw new Error('server-error');
    }
    if (error?.response?.data?.error === 'invalid session token') {
      throw new Error('invalid-session-token');
    }
    if (error?.response?.data?.code === 'unauthorized') {
      throw new Error('invalid-session-token');
    }
    return Promise.reject(error);
  },
);

export default baseAPI;
